import { createAction } from 'redux-actions';
import callApi from '../../util/apiCaller';

export const unsubscribeSuccess = createAction('UNSUBSCRIBE_SUCCESS');
export const unsubscribeFailure = createAction('UNSUBSCRIBE_FAILURE');

export function unsubscribe(token) {
  return dispatch => {
    return callApi(dispatch, `public/people/${token}/unsubscribe`, null, 'get')
      .then(res => {
        const { language, brand, topColor, buttonColor, logoUrl } = res;
        dispatch(
          unsubscribeSuccess({
            person: {
              language,
              brand,
              topColor,
              buttonColor,
              logoUrl,
            },
          }),
        );
        return true;
      })
      .catch(err => {
        dispatch(unsubscribeFailure(err));
        return false;
      });
  };
}

export function unsubscribeFromLink(linkId, email) {
  return dispatch => {
    return callApi(dispatch, `public/link/${linkId}/unsubscribe`, null, 'post', { email })
      .then(res => {
        const { language, brand, topColor, buttonColor, logoUrl } = res;
        dispatch(
          unsubscribeSuccess({
            person: {
              language,
              brand,
              topColor,
              buttonColor,
              logoUrl,
            },
          }),
        );
        return true;
      })
      .catch(err => {
        dispatch(unsubscribeFailure(err));
        return false;
      });
  };
}
